import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/updateFastShippingCopyMeganavLG/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const activeUpdateFastShippingCopyMeganavLGSelector = createSelector(
    isTestTargetReadySelector,
    activeSelector,
    (testReady, active) => testReady && active
);

export { activeUpdateFastShippingCopyMeganavLGSelector };
